import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, TagSelect } from 'tea-component';

import { gptGetEmail, gptSetEmail } from '@op/services';

import '../styles/index.scss';

import TipsModal from './tips-modal';
import moment from 'moment';
import { notificationError, notificationSuccess } from '../constant';
import { CONTACT_NAME } from '@op/constants';
import { getLocale, useIntl } from 'umi';

export default function EmailModal(props) {
  const { formatMessage } = useIntl();
  const locale = getLocale();

  const { value, setValue, params } = props;

  const [emailInputError, setEmailInputError] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);

  const [tipsVisible, setTipsVisible] = useState(false);

  const [visible, setVisible] = useState(value);
  const [emails, setEmails] = useState<string[]>([]);
  const [selectEmails, setSelectEmails] = useState<string[]>([]);
  const [newMdFile, setNewMdFile] = useState('');

  const [hasRecord, setHasRecord] = useState(false);

  useEffect(() => {
    setVisible(value);
  }, [value]);

  const close = () => {
    setVisible(false);
    setValue?.(false);
  };

  async function check() {
    try {
      const data = await gptGetEmail({
        ...params,
        type: 'gpt',
        top_n: 1,
      });

      if (data && Array.isArray(data) && data.length > 0) {
        // 以前是有记录的
        console.log('modal 之前的记录', data);
        setHasRecord(true);
        const { emails: curEmails = [] } = data?.[0] || {};
        console.log('modal 之前的记录', curEmails);
        if (curEmails && Array.isArray(curEmails) && curEmails.length > 0) {
          setEmails(curEmails);
          setSelectEmails(curEmails);
        }
      } else {
        // 以前是没有记录的
        setHasRecord(false);
        const data = await gptGetEmail({
          ...params,
          type: 'user',
          top_n: 1,
        });

        if (data && Array.isArray(data) && data.length > 0) {
          // 以前是有记录的
          console.log('modal 之前的记录', data);

          const { emails: curEmails = [] } = data?.[0] || {};

          console.log('modal 之前的记录', emails);

          if (curEmails && Array.isArray(curEmails) && curEmails.length > 0) {
            setEmails(curEmails);
            setSelectEmails(curEmails);
          }
        }
      }
    } catch {
      notificationError();
    }
  }

  useEffect(() => {
    // 监听窗口打开情况

    if (visible) {
      // 打开窗口
      check();
    } else {
      // 关闭窗口
      handleClose();
    }
  }, [visible, params]);

  const handleConfirm = async () => {
    setEmailInputError('');

    if (
      !selectEmails ||
      !Array.isArray(selectEmails) ||
      selectEmails.length === 0
    ) {
      setEmailInputError('Please enter your email address.');
      return;
    }

    if (
      !selectEmails.every((item) =>
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(item),
      )
    ) {
      setEmailInputError('Please enter the correct email address.');
      return;
    }
    setSubmitLoading(true);

    try {
      const { type, ...setEmailParams } = params;
      const data = await gptSetEmail({
        ...setEmailParams,
        emails: selectEmails,

        page_url: window.location.href,
      });

      setSubmitLoading(false);

      if (data && Array.isArray(data) && data.length > 0) {
        // 以前是有记录的
        console.log('modal 之前的记录', data);

        const { md_file = '' } = data?.[0] || {};

        if (md_file) {
          setNewMdFile(md_file);
          setTipsVisible(true);
        }
        close();
      } else {
        notificationSuccess();
        close();
      }
    } catch (error: any) {
      if (error?.code === 30017) {
        // The email has been sent and the operation failed
        notificationError(error?.msg);
      } else {
        notificationError();
      }
      setSubmitLoading(false);
    }
  };

  const handleNewMdFile = () => {
    props.handleNewMdFile?.(newMdFile);
  };

  const handleClose = () => {
    setEmails([]);
    setSelectEmails([]);
    setEmailInputError('');
    close();
  };

  return (
    <>
      <TipsModal
        value={tipsVisible}
        setValue={setTipsVisible}
        handleConfirm={handleNewMdFile}
      ></TipsModal>
      <Modal
        visible={visible}
        caption={formatMessage({ id: 'Notice' })}
        onClose={close}
        className="dbo-gpt-email-modal"
      >
        <Modal.Body>
          <>
            {hasRecord ? (
              <>
                {locale === 'en-US' ? (
                  <p className="dbo-gpt-email-tips">
                    A GPT report is being generated for you from{' '}
                    {moment(params?.start_time).format('YYYY-MM-DD')} to
                    {moment(params?.end_time).format('YYYY-MM-DD')}, and will
                    send the report to the email address below.
                  </p>
                ) : (
                  <p className="dbo-gpt-email-tips">
                    正在为您生成{' '}
                    {moment(params?.start_time).format('YYYY-MM-DD')}至
                    {moment(params?.end_time).format('YYYY-MM-DD')}
                    的GPT舆情报告，并将把报告发送到以下的邮箱地址。
                  </p>
                )}
              </>
            ) : (
              <>
                {locale === 'en-US' ? (
                  <p className="dbo-gpt-email-tips">
                    A GPT report will be generated for you from{' '}
                    {moment(params?.start_time).format('YYYY-MM-DD')} to{' '}
                    {moment(params?.end_time).format('YYYY-MM-DD')}. Could you
                    please confirm the email address to receive the report?
                    <br />
                    Note: GPT tasks have time/data limits. For long-term data
                    (such as 1 year), please contact {CONTACT_NAME} directly.
                  </p>
                ) : (
                  <p className="dbo-gpt-email-tips">
                    将为您生成 {moment(params?.start_time).format('YYYY-MM-DD')}{' '}
                    至{moment(params?.end_time).format('YYYY-MM-DD')}{' '}
                    的GPT舆情报告。请确认接收报告的邮箱地址
                    <br />
                    注意：GPT任务存在时间/数据量限制。如需获取长时间范围数据（如1年），请直接联系{CONTACT_NAME}。
                  </p>
                )}
              </>
            )}

            <Form className="dbo-gpt-email-form">
              <Form.Item
                label={formatMessage({ id: 'Email Address' })}
                status={emailInputError ? 'error' : undefined}
                message={emailInputError}
              >
                <TagSelect
                  // optionsOnly
                  options={emails.map((item) => ({
                    text: item,
                    value: item,
                  }))}
                  defaultValue={[]}
                  value={selectEmails}
                  onChange={(tags) => setSelectEmails(tags)}
                  boxClassName="summary-email-filter"
                  placeholder="Please enter a Email"
                />
              </Form.Item>
            </Form>
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={handleConfirm}
            loading={submitLoading}
          >
            {submitLoading ? '' : formatMessage({ id: 'Confirm' })}
          </Button>
          <Button type="weak" onClick={handleClose}>
            {formatMessage({ id: 'Cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
